/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Plan_Choose_T2Inputs */

const en_dr_plan_choose_t2 = /** @type {(inputs: Dr_Plan_Choose_T2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden ideas → vote`)
};

const id_dr_plan_choose_t2 = /** @type {(inputs: Dr_Plan_Choose_T2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ide tersembunyi → vote`)
};

/**
* | output |
* | --- |
* | "Hidden ideas → vote" |
*
* @param {Dr_Plan_Choose_T2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_plan_choose_t2 = /** @type {((inputs?: Dr_Plan_Choose_T2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Plan_Choose_T2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_plan_choose_t2(inputs)
	return en_dr_plan_choose_t2(inputs)
});